module.exports = __webpack_public_path__ + "static/media/j4crew-logo-new.3e8c0ff8.svg";